<template>
    <div id="app">
        <div class="contentBox">
            <div class="topImg">
                <div>
                    <p>职位总数</p>
                    <p>{{positionNumber}}</p>
                    <img src="@/assets/imgs/positionnumber.png" alt />
                </div>
                <div>
                    <p>在招职位</p>
                    <p>{{recruitingNumber}}</p>
                    <img src="@/assets/imgs/onposition.png" alt />
                </div>
                <div>
                    <p>已收简历数</p>
                    <p>{{receivedNumber}}</p>
                    <img src="@/assets/imgs/resumunumber.png" alt />
                </div>
                <div>
                    <p>昨日新增简历数</p>
                    <p>{{newNumber}}</p>
                    <img src="@/assets/imgs/lastresume.png" alt />
                </div>
            </div>
            <div class="bottomimg">
                <img src="@/assets/imgs/contentpage.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
    import BasicDataApi from "@/api/BasicDataModule"
    export default {
        data() {
            return {
                // 职位总数
                positionNumber: "",
                // 在招职位数
                recruitingNumber: "",
                // 已收简历数
                receivedNumber: "",
                // 昨日新增数
                newNumber: ""
            }
        },
        created() {
            this.handleGetBasicData();
        },
        methods: {
            // 获取首页基础数据
            handleGetBasicData() {
                BasicDataApi.getBasicData()
                    .then((res) => {
                        this.positionNumber = res.data.data.position_total_num;
                        this.recruitingNumber = res.data.data.position_recruit_num;
                        this.receivedNumber = res.data.data.cv_receive_num;
                        this.newNumber = res.data.data.cv_add_num;
                    }).catch((err) => {
                        console.log(err)
                    });
            }
        }
    };
</script>
<style scoped>
    #app {
        /* overflow: hidden; */
    }

    .contentBox {
        /* position: absolute;
    top: 84px;
    bottom: 0;
    overflow: auto; */
        width: 1080px;
        background-color: #ffffff;
        border-radius: 5px;
    }

    .contentBox .topImg {
        width: 1020px;
        height: 157px;
        display: flex;
    }

    .contentBox .topImg div {
        flex: 25%;
        height: 100%;
        text-align: center;
    }

    .contentBox .topImg div p:first-child {
        margin-top: 24px;
        font-size: 16px;
        color: rgba(51, 51, 51, 1);
    }

    .contentBox .topImg div p:nth-child(2) {
        margin-top: 8px;
        font-size: 32px;
        color: #0077FF;
        margin-bottom: 22px;
    }

    .contentBox .topImg div img {
        display: inline-block;
        width: 42px;
        height: 13px;
    }

    .bottomimg {
        width: 881px;
        height: 408px;
        margin: 30px auto;
        margin-bottom: 0;
    }

    .bottomimg img {
        display: inline-block;
        width: 100%;
        height: 100%;

    }
</style>


// WEBPACK FOOTER //
// src/views/datas/basic.vue